import { render, staticRenderFns } from "./ProducersTableInfo.vue?vue&type=template&id=4d44b98c&"
import script from "./ProducersTableInfo.vue?vue&type=script&lang=js&"
export * from "./ProducersTableInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports